export default "__VITE_ASSET__CVhOtscq__"